import { useEffect, useRef, useState, useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';

import useWiki from '../hooks/Wiki'
import usePageDetails from '../hooks/PageDetails'

import WikiArticle from './WikiArticle';

const Wikirun = ({ show, page, target, advance, settings }) => {
  const [nextTitle, setNextTitle] = useState("")
  const nodeRef = useRef();

  const [nextPage] = usePageDetails(nextTitle);
  const { html: wikiContent, loading } = useWiki(page?.id);

  // Advance when next page details have loaded
  useEffect(() => {
    if (nextPage) advance(({ id: nextPage.id, title: nextPage.title }));
    setNextTitle("");
  }, [nextPage, advance]);

  // Scroll to top on page change
  useEffect(() => { if (!loading) window.scrollTo(0, 0) }, [loading, show]);
  // Scroll to top on visibility change
  useEffect(() => window.scrollTo(0, 0), [show]);

  const handleNavigate = useCallback(title => {
    setNextTitle(title);
  }, []);

  return (
    <CSSTransition in={show} nodeRef={nodeRef} timeout={3000}>
      <div className='wiki-run' ref={nodeRef}>
        <WikiArticle
          wikiContent={wikiContent}
          loading={loading}
          settings={settings}
          target={target}
          onNavigate={handleNavigate}
        />
      </div>
    </CSSTransition>
  )
}

export default Wikirun;
